import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Perks of Partnering with an Expert Magento Development Company USA
            </h2>
            <p>
              Collaborating with a professional Magento store development
              company ensures access to specialized expertise & in-depth
              knowledge of the Magento platform. Leveraging the experience of an
              expert team streamlines the development process, ensuring
              efficient, scalable, and high-quality Magento solutions.
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>Innovative<br/>Solutions</h4>
                <p>
                  Access to cutting-edge technology and innovative approaches
                  for tailored Magento solutions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>Extensive <br/>Expertise</h4>
                <p>
                  Leveraging a wealth of experience and specialized knowledge in
                  Magento's intricacies and functionalities.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>Customized <br/>Solution</h4>
                <p>
                  Tailored solutions aligned with specific business needs,
                  ensuring a unique and personalized online store.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box">
              <div className="perks-content">
                <h4>Ongoing<br/> Support</h4>
                <p>
                  Continuous maintenance, updates, and support for sustained
                  performance and adaptation to evolving needs.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
